import { ThunkDispatch } from "redux-thunk";
import RootState from "../../state";
import { getDirectoryOwnersLoading, OwnersAction } from "./actions";
import * as DirectoryAPI from "services/api/api.externalDirectory";
import { IOwnersActionTypes } from "./types";
import logger from "logger";

export const getDirectoryOwners = () => {
    return async (
        dispatch: ThunkDispatch<RootState, undefined, OwnersAction>,
        getState: () => RootState
    ) => {
        try {
            dispatch(getDirectoryOwnersLoading(true));

            const { app, auth } = getState();

            const response = await DirectoryAPI.getDirectoryOwners(
                app.ID,
                auth.token!
            );

            dispatch({
                type: IOwnersActionTypes.GET_OWNERS,
                payload: response.data,
            });

            dispatch(getDirectoryOwnersLoading(false));
        } catch (err) {
            logger.error("GET-DIRECTORY-OWNERS", err as object);
        }
    };
};
